import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import BuildIcon from '@material-ui/icons/Build';
import { assign } from 'lodash';

import { UnidataTable, Table, Tabela, Modal } from '~/components';
import { t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';
import {
  dataInRequest,
  findData,
  recordFiltering,
} from '~/store/modules/manutencaoDvec/actions';

import ConfirmDialog from './components/ConfirmDialog';
import * as S from './styles';

function ManutencaoList() {
  const dispatch = useDispatch();
  const redux = useSelector((state) => state.manutencaoDvec);

  const [loading, setLoading] = useState(false);
  const [handleConfirmModal, setHandleConfirmModal] = useState(false);
  const [item, setItem] = useState();
  const [items, setItems] = useState({
    detalhe: [],
  });

  const handleUpdate = (params = {}) => {
    setHandleConfirmModal(false);
    dispatch(recordFiltering(assign(redux?.params, params)));
  };

  const buttons = useMemo(
    () => [
      {
        title: t('s.menu.operacao.manutencaodvec'),
        action: () => setHandleConfirmModal(true),
        icon: <BuildIcon />,
        disabled:
          item?.statusveiculo === 'L' ? item?.afericaodvecveiculo == 'A' : 'N',
      },
    ],
    [item]
  );

  const statusAfericao = useMemo(
    () => [
      { label: 'A', value: t('s.geral.aguardandoatualizacaodvec') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
    ],
    []
  );

  const status = useMemo(
    () => [
      { label: 'N', value: t('s.geral.opcoes.nao') },
      { label: 'S', value: t('s.geral.opcoes.sim') },
    ],
    []
  );

  const handleSubmit = useCallback(async () => {
    try {
      await api.put(`afericaodvecs/manutencao/colocar/${item.idveiculo}`);
    } catch (err) {
      console.log(err);
      toast.error(err);
    } finally {
      toast.success(t('s.geral.sucessoalteracao'));
      handleUpdate();
    }
  }, [items]);

  const handleResponseDataItems = useCallback(
    async (props) => {
      setItem(props);
      try {
        if (props.idveiculo) {
          setLoading(true);

          await api
            .get(`afericaodvecs/detalhemanutencaodvec/${props.idveiculo}`)
            .then((response) => setItems(response.data));
        }
      } catch (err) {
        getToastErrors(err);
      } finally {
        setLoading(false);
      }
    },
    [item]
  );

  const header = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.cadastro.veiculo.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.geral.camposistema.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculostr',
        label: t('s.operacao.limpezatag.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.veiculo.idmodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'afericaodvecveiculo',
        label: t('s.geral.emafericao'),
        format: (value) =>
          statusAfericao.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: statusAfericao },
      },
      {
        id: 'manutencaodvec',
        label: t('s.geral.emmanutencao'),
        format: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    []
  );

  const cellsStock = useMemo(
    () => [
      {
        id: 'datainiciomanutencaodvec',
        label: t('s.geral.camposistema.datahorainicialafericao'),
      },
      {
        id: 'codigousuarioiniciomanutencaodvec',
        label: t('s.geral.usuarioinicial'),
      },
      {
        id: 'datafimmanutencaodvec',
        label: t('s.geral.camposistema.datahorafinalafericao'),
      },
      {
        id: 'codigousuariofimmanutencaodvec',
        label: t('s.geral.usuariofinal'),
      },
      {
        id: 'motivoiniciomanutencaodvec',
        label: t('s.geral.camposistema.motivoiniciomanutencaodvec'),
      },
    ],

    []
  );
  useEffect(() => {
    if (redux.loading) {
      setItems({});
    }
  }, [redux.loading]);

  return (
    <>
      <S.Container>
        <Tabela
          read={dataInRequest}
          state={redux}
          noCreate
          noEdition
          header={header}
          onCallback={(value) => handleResponseDataItems(value)}
          headerMobile="nomeempresaveiculostr"
          detach="nomeempresaveiculostr"
          unique={['idveiculo']}
          findItem={findData}
          recordFilter={recordFiltering}
          buttons={buttons}
        />

        <S.Wrapper>
          <Table
            isResponsive
            size="small"
            height="18rem"
            paginate={99}
            showPagination={false}
            cells={cellsStock}
            data={items.detalhe ?? []}
            loding={loading}
          />
        </S.Wrapper>
      </S.Container>
      <ConfirmDialog
        open={handleConfirmModal}
        onClose={handleUpdate}
        selectedValue={item}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default ManutencaoList;
